module.exports = __webpack_public_path__ + "img/camila.c67869fe.webp";